<template>
  <div class="profile-steps">
    <div class="md-layout">
      <div
        class="md-layout-item md-medium-size-100 md-xsmall-size-100 md-size-100 cus-step-wrap"
      >
        <div class="flex_content py-4 mb-4">
          <!--<h1 class="section_header m-0">Company Report</h1>-->
          <ProgressBar :scale="progress" v-if="$route.query['data-id']" />
        </div>
        <div class="step-progress__wrapper">
          <div class="step-progress__bar md-layout">
            <div
              class="md-medium-size-33 md-layout-item md-xsmall-size-100 custom-step-pro p-0"
            >
              <div
                id="industryDiv"
                class="step-progress__step step-progress__step--valid"
                @click="selectedTab($event)"
              >
                <span class="step">1</span>
                <div class="step-progress__step-icon fa fa-check"></div>
                <div class="step-progress__step-label">
                  <div class="arrow-up"></div>
                  Industry
                </div>
                <div class="step-progress__step-sub-label">
                  <div class="progress-step-actions">
                    <div class="action-text">
                      {{
                        getData(this.industry)
                          ? getData(this.industry)
                          : "Select Industry"
                      }}
                      <md-icon
                        @click.native="resetIndustry"
                        v-if="this.industry != null"
                        class="action-icon"
                        >replay
                      </md-icon>
                    </div>
                    <div
                      class="favourite black-color"
                      v-if="this.industry != null"
                    >
                      <md-icon
                        @click.native="favoriteIndustry"
                        v-if="this.industry != null"
                        class="action-icon"
                        >star </md-icon
                      >Add to Favorite
                    </div>
                  </div>
                </div>
                <div class="dropdownMenu">
                  <nav-tabs-card no-label md-elevation="0">
                    <template slot="content">
                      <md-tabs md-alignment="left" id="finantialProfileTabs">
                        <industry-tab />
                      </md-tabs>
                    </template>
                  </nav-tabs-card>
                </div>
              </div>
              <div
                id="favouriteIndustryDiv"
                :class="
                  this.isRetail
                    ? 'non-subscriber favourite_list'
                    : 'favourite_list'
                "
                @click="isRetail ? {} : favorites($event)"
              >
                <md-tooltip
                  v-if="this.isRetail"
                  md-direction="right"
                  class="width-tooltip"
                  >Upgrade to a subscription to access this feature</md-tooltip
                >
                <i class="md-icon">star</i>Favorite Industries
                <div class="dropdownMenu">
                  <sidebar-search tab="industry" title="Favorite Industries" />
                </div>
                <div id="industry_notify" class="notify">
                  Successfully Added to Favorite
                </div>
              </div>
            </div>
            <div
              class="md-medium-size-33 md-layout-item md-xsmall-size-100 custom-step-pro p-0"
            >
              <div
                id="marketDiv"
                class="step-progress__step step-progress__step--valid"
                @click="selectedTab($event)"
              >
                <span class="step">2</span>
                <div class="step-progress__step-icon fa fa-check"></div>
                <div class="step-progress__step-label">
                  Market Area
                  <div class="arrow-up"></div>
                </div>
                <div class="step-progress__step-sub-label">
                  <div class="progress-step-actions">
                    <div class="action-text">
                      {{
                        getTitle(this.marketArea)
                          ? getTitle(this.marketArea)
                          : "Select Area"
                      }}
                      <md-icon
                        @click.native="resetMarket"
                        v-if="this.marketArea != null"
                        class="action-icon"
                        >replay
                      </md-icon>
                    </div>
                    <div
                      class="favourite black-color"
                      v-if="this.marketArea != null"
                    >
                      <md-icon
                        @click.native="favoriteMarket"
                        v-if="this.marketArea != null"
                        class="action-icon"
                        >star </md-icon
                      >Favorite Market Areas
                    </div>
                  </div>
                </div>
                <div class="dropdownMenu">
                  <nav-tabs-card no-label md-elevation="0">
                    <template slot="content">
                      <md-tabs md-alignment="left" id="finantialProfileTabs">
                        <market-area-tab />
                      </md-tabs>
                    </template>
                  </nav-tabs-card>
                </div>
              </div>
              <div
                id="favouriteAreaDiv"
                :class="
                  this.isRetail
                    ? 'non-subscriber favourite_list'
                    : 'favourite_list'
                "
                @click="isRetail ? {} : favorites($event)"
              >
                <md-tooltip
                  v-if="this.isRetail"
                  md-direction="right"
                  class="width-tooltip"
                  >Upgrade to a subscription to access this feature</md-tooltip
                >
                <i class="md-icon">star</i>Favorite Market Areas
                <div class="dropdownMenu">
                  <sidebar-search
                    tab="market_area"
                    title="Favorite Market Areas"
                  />
                </div>
                <div id="market_notify" class="notify">
                  Successfully Added to Favorite
                </div>
              </div>
            </div>
            <div
              class="md-medium-size-33 md-layout-item md-xsmall-size-100 custom-step-pro p-0"
            >
              <div
                id="salesDiv"
                class="step-progress__step step-progress__step--valid"
                @click="selectedTab($event)"
              >
                <span class="step">3</span>
                <div class="step-progress__step-icon fa fa-check"></div>
                <div class="step-progress__step-label">
                  Sales Class
                  <div class="arrow-up"></div>
                </div>
                <div class="step-progress__step-sub-label">
                  <div class="progress-step-actions">
                    <div class="action-text">
                      {{
                        getTitle(this.salesClass)
                          ? getTitle(this.salesClass)
                          : "Select Sales Class"
                      }}
                      <md-icon
                        @click.native="resetSales"
                        v-if="this.salesClass != null"
                        class="action-icon"
                      >
                        replay</md-icon
                      >
                    </div>
                    <div
                      class="favourite black-color"
                      v-if="this.salesClass != null"
                    >
                      <md-icon
                        @click.native="favoriteSales"
                        v-if="this.salesClass != null"
                        class="action-icon"
                        >star </md-icon
                      >Favorite Sale Classes
                    </div>
                  </div>
                </div>
                <div class="dropdownMenu">
                  <nav-tabs-card no-label md-elevation="0">
                    <template slot="content">
                      <md-tabs md-alignment="left" id="finantialProfileTabs">
                        <sales-class-tab />
                      </md-tabs>
                    </template>
                  </nav-tabs-card>
                </div>
              </div>
              <div
                id="favouriteSalesDiv"
                :class="
                  this.isRetail
                    ? 'non-subscriber favourite_list'
                    : 'favourite_list'
                "
                @click="isRetail ? {} : favorites($event)"
              >
                <md-tooltip
                  v-if="this.isRetail"
                  md-direction="right"
                  class="width-tooltip"
                  >Upgrade to a subscription to access this feature</md-tooltip
                >
                <i class="md-icon">star</i>Favorite Sale Classes
                <div class="dropdownMenu">
                  <sidebar-search
                    tab="sales_class"
                    title="Favorite Sale Classes"
                  />
                </div>
                <div id="sale_notify" class="notify">
                  Successfully Added to Favorite
                </div>
              </div>
            </div>
          </div>
          <!-- <div class="step-progress__wrapper-after"></div> -->
        </div>
      </div>
    </div>
    <modal v-if="classicModal" @close="classicModal = false">
      <template slot="header">
        <h4 class="modal-title">Industry Profile Version</h4>
        <md-button
          class="md-simple md-just-icon md-round modal-default-button"
          @click="classicModal = false"
        >
          <md-icon>clear</md-icon>
        </md-button>
      </template>

      <template slot="body">
        <p>
          This is where we will explain the difference between a regular IF
          profile and a SPIF profile.
        </p>
      </template>

      <template slot="footer">
        <md-button class="md-simple">Nice Button</md-button>
        <md-button class="md-danger md-simple" @click="classicModal = false"
          >Close</md-button
        >
      </template>
    </modal>
  </div>
</template>

<script>
import { Modal, ProgressBar } from "@/components";
import axios from "axios";
import { NavTabsCard } from "@/components";
import IndustryTab from "./IndustryTab";
import MarketAreaTab from "./MarketAreaTab";
import SalesClassTab from "./SalesClassTab";
import SidebarSearch from "./SidebarSearch";
import { mapState } from "vuex";

export default {
  name: "profile-steps",
  components: {
    Modal,
    NavTabsCard,
    IndustryTab,
    MarketAreaTab,
    SalesClassTab,
    SidebarSearch,
    ProgressBar,
  },
  data() {
    return {
      radioType: false,
      radioSeries: true,
      classicModal: false,
      progress: 70,
    };
  },
  methods: {
    openSelector(event) {
      let selectorDiv = null;

      if (event.target.classList.contains("industry"))
        selectorDiv = document.getElementById("industryDiv");
      else if (event.target.classList.contains("area"))
        selectorDiv = document.getElementById("marketDiv");
      else if (event.target.classList.contains("sales"))
        selectorDiv = document.getElementById("salesDiv");
      else if (event.target.classList.contains("structure"))
        selectorDiv = document.getElementById("divStructure");
      else if (event.target.classList.contains("series"))
        selectorDiv = document.getElementById("divSeries");

      if (selectorDiv.classList.contains("open"))
        selectorDiv.classList.remove("open");
      else selectorDiv.classList.add("open");
    },
    selectPanel(e) {
      let activeClass = e.target.parentElement;
      if (activeClass.classList.contains("open")) {
        activeClass.classList.remove("open");
      } else {
        activeClass.classList.add("open");
      }
    },
    getData: function(name) {
      if (name) {
        return name.split("[")[1].split("]")[0];
      }
    },
    getTitle: function(name) {
      if (name) {
        return name.split("[")[0];
      }
    },
    favoriteIndustry: async function() {
      let notify = document.getElementById("industry_notify");
      let currentSession = localStorage.getItem(
        "vue-authenticate.vueauth_access_token"
      );

      const industryData = this.getData(this.industry);

      await axios
        .post(
          process.env.VUE_APP_API_BASE_URL + "/user/favorites/add",
          {},
          {
            params: {
              session_id: currentSession,
              category1: "universal",
              category2: "industry",
              data: industryData,
              search1: this.industry,
              search2: industryData,
            },
          }
        )
        .then((res) => {
          if (res.hasOwnProperty("data") && res.data.error) {
            this.$store.commit("SET_ERROR_BIT", true);
            this.$store.commit(
              "SET_ERROR_INFO",
              "<br>" +
                "Server responded with error = True <br> errorCode: " +
                res.data.errorCode +
                `<br> ${process.env.VUE_APP_API_BASE_URL} + "/user/favorites/add" <br>`
            );
            throw new Error(
              "<br>" +
                "Server responded with error = True <br> errorCode: " +
                res.data.errorCode
            );
          }
          this.$store.commit("C_PUSH_TO_FAVORITE_INDUSTRIES", {
            data: industryData,
            search1: this.industry,
            id: res.data.favorite_id,
          });
          notify.classList.add("show");
          setTimeout(function() {
            notify.classList.remove("show");
          }, 3000);
        });
    },
    favoriteMarket: async function() {
      let notify = document.getElementById("market_notify");
      let currentSession = localStorage.getItem(
        "vue-authenticate.vueauth_access_token"
      );

      const marketData = this.getData(this.marketArea);

      await axios
        .post(
          process.env.VUE_APP_API_BASE_URL + "/user/favorites/add",
          {},
          {
            params: {
              session_id: currentSession,
              category1: "universal",
              category2: "market_area",
              data: marketData,
              search1: this.marketArea,
              search2: marketData,
            },
          }
        )
        .then((res) => {
          if (res.hasOwnProperty("data") && res.data.error) {
            this.$store.commit("SET_ERROR_BIT", true);
            this.$store.commit(
              "SET_ERROR_INFO",
              "<br>" +
                "Server responded with error = True <br> errorCode: " +
                res.data.errorCode +
                `<br> ${process.env.VUE_APP_API_BASE_URL} + "/user/favorites/add" <br>`
            );
            throw new Error(
              "<br>" +
                "Server responded with error = True <br> errorCode: " +
                res.data.errorCode
            );
          }
          this.$store.commit("C_PUSH_TO_FAVORITE_MARKET_AREAS", {
            data: marketData,
            search1: this.marketArea,
            id: res.data.favorite_id,
          });
          notify.classList.add("show");
          setTimeout(function() {
            notify.classList.remove("show");
          }, 3000);
        });
    },
    favoriteSales: async function() {
      let notify = document.getElementById("sale_notify");
      let currentSession = localStorage.getItem(
        "vue-authenticate.vueauth_access_token"
      );

      const salesData = this.getData(this.salesClass);
      await axios
        .post(
          process.env.VUE_APP_API_BASE_URL + "/user/favorites/add",
          {},
          {
            params: {
              session_id: currentSession,
              category1: "universal",
              category2: "sales_class",
              data: salesData,
              search1: this.salesClass,
              search2: salesData,
            },
          }
        )
        .then((res) => {
          if (res.hasOwnProperty("data") && res.data.error) {
            this.$store.commit("SET_ERROR_BIT", true);
            this.$store.commit(
              "SET_ERROR_INFO",
              "<br>" +
                "Server responded with error = True <br> errorCode: " +
                res.data.errorCode +
                `<br> ${process.env.VUE_APP_API_BASE_URL} + "/user/favorites/add" <br>`
            );
            throw new Error(
              "<br>" +
                "Server responded with error = True <br> errorCode: " +
                res.data.errorCode
            );
          }
          this.$store.commit("C_PUSH_TO_FAVORITE_SALES_CLASSES", {
            data: salesData,
            search1: this.salesClass,
            id: res.data.favorite_id,
          });

          notify.classList.add("show");
          setTimeout(function() {
            notify.classList.remove("show");
          }, 3000);
        });
    },
    resetIndustry: async function() {
      this.$store.commit("C_SET_INDUSTRY", null);
      this.$store.commit("C_SET_SEARCH_INDUSTRIES", null);
      this.$store.commit("C_SET_SEARCH_LOADING_INDUSTRY", false);
    },
    resetMarket: async function() {
      this.$store.commit("C_SET_MARKET_AREA", null);
    },
    resetSales: async function() {
      this.$store.commit("C_SET_SALES_CLASS", null);
    },
    toArray: function(arrLike) {
      return [].slice.call(arrLike);
    },
    setMarketClass: function() {
      if (this.marketArea != null) {
        document
          .querySelector("#marketDiv")
          .classList.remove("step-progress__step--valid");
        document
          .querySelector("#marketDiv")
          .classList.add("step-progress__step--active");
      } else {
        document
          .querySelector("#marketDiv")
          .classList.remove("step-progress__step--active");
        document
          .querySelector("#marketDiv")
          .classList.add("step-progress__step--valid");
      }
    },
    setSalesClass: function() {
      if (this.salesClass != null) {
        document
          .querySelector("#salesDiv")
          .classList.remove("step-progress__step--valid");
        document
          .querySelector("#salesDiv")
          .classList.add("step-progress__step--active");
      } else {
        document
          .querySelector("#salesDiv")
          .classList.remove("step-progress__step--active");
        document
          .querySelector("#salesDiv")
          .classList.add("step-progress__step--valid");
      }
    },
    setIndustryClass: function() {
      let div = document.querySelector("#industryDiv");

      if (div) {
        if (this.industry != null) {
          div.classList.remove("step-progress__step--valid");
          div.classList.add("step-progress__step--active");
        } else {
          div.classList.remove("step-progress__step--active");
          div.classList.add("step-progress__step--valid");
        }
      }
    },
    favorites: function(e) {
      let activeClass = e.target;
      this.validateClickOutside(activeClass);
      if (activeClass.classList.contains("open")) {
        activeClass.classList.remove("open");
      } else {
        activeClass.classList.add("open");
      }
    },
    selectedTab: function(e) {
      let activeClass = e.target.parentElement;

      if (activeClass.classList.contains("open")) {
        activeClass.classList.remove("open");
        this.validateClickOutside(activeClass);
        e.stopPropagation();
      } else {
        this.validateClickOutside(activeClass);
        e.stopPropagation();
        let elems = document.querySelector(".progress-step-actions");

        [].forEach.call(elems, function(el) {
          el.classList.remove("open");
        });

        activeClass.classList.add("open");

        // activeClass.nextElementSibling.classList.remove('open');
      }
      let elems = this.toArray(document.querySelectorAll(".md-tab-nav-button"));

      elems.forEach(function(el) {
        el.classList.remove("md-active");
      });

      let currentTab = parseInt(e.currentTarget.firstElementChild.innerText);
      document
        .querySelectorAll(".md-tab-nav-button")
        [currentTab - 1].classList.add("md-active");
    },
    validateClickOutside: function(activeClass) {
      let openClass = document.getElementsByClassName("open");
      if (openClass)
        [].forEach.call(openClass, function(el) {
          if (activeClass.id) el.classList.remove("open");
        });
    },
  },

  computed: {
    ...mapState({
      isRetail: (state) =>
        state.user.user_type.retail/* || state.user.allow_retail*/ ? true : null,
    }),
    profileId() {
      return this.$store.getters.profileId;
    },
    industry() {
      return this.$store.getters.cIndustry;
    },
    marketArea() {
      return this.$store.getters.cMarketArea;
    },
    salesClass() {
      return this.$store.getters.cSalesClass;
    },
  },
  watch: {
    industry(newValue, oldValue) {
      this.setIndustryClass();
      if (newValue) {
        this.progress += 10;
      }
      if (oldValue) {
        this.progress -= 10;
      }
    },
    marketArea(newValue, oldValue) {
      this.setMarketClass();
      if (newValue) {
        this.progress += 10;
      }
      if (oldValue) {
        this.progress -= 10;
      }
    },
    salesClass(newValue, oldValue) {
      this.setSalesClass();
      if (newValue) {
        this.progress += 10;
      }
      if (oldValue) {
        this.progress -= 10;
      }
    },
  },
};
</script>
<style lang="scss" scoped>
.info-btn-custom {
  background-color: white !important;

  &:hover {
    background-color: white !important;
    box-shadow: none;
  }
}
.step-progress__step:hover {
  cursor: pointer;
}

.action-text {
  opacity: 1 !important;
  transform: unset !important;
  font-size: 14px !important;
}

.custom-step-pro::before {
  content: "";
  position: absolute;
  left: 50%;
  top: 50%;
  height: 2px;
  width: 96%;
  background-color: grey;
  z-index: -1;
}

.custom-step-pro:last-child::before {
  content: none;
}

@media screen and (max-width: 1280px) and (min-width: 600px) {
  .custom-step-pro:nth-child(4),
  .custom-step-pro:nth-child(5) {
    margin-top: 130px;
  }

  .custom-step-pro:nth-child(3)::before {
    content: none;
  }

  .cus-step-wrap {
    padding-top: 20px;
  }

  .step-progress__step:after {
    width: 30px !important;
    height: 30px !important;
  }

  .step-progress__step span {
    font-size: 18px;
  }

  .step-progress__step-icon {
    font-size: 12px !important;
  }
}

@media only screen and (max-width: 600px) {
  .custom-step-pro::before {
    left: -6%;
    top: 369%;
    width: 27%;
    transform: rotate(90deg);
  }

  .custom-step-pro {
    margin-bottom: 80px;
  }

  .step-progress__step-label .arrow-up {
    display: none;
  }

  .step-progress__step:after {
    left: 8%;
    top: 150%;
  }

  .step-progress__step-icon {
    left: 8%;
    top: 150%;
  }

  .step-progress__step-label {
    top: 0;
    left: 63%;
  }

  .custom-step-pro:nth-child(4),
  .custom-step-pro:nth-child(5) {
    margin-top: unset;
  }

  .step-progress__step:after {
    width: 30px !important;
    height: 30px !important;
  }

  .step-progress__step span {
    font-size: 18px;
  }
  .step-progress__step-icon {
    font-size: 12px !important;
  }
  .cus-step-wrap {
    padding-top: 20px;
  }
}
</style>
